module.exports = __webpack_public_path__ + "img/testimonials-trustpilot-logo.b43a38fc.svg";